import types from './FileUploaderErrorType';

export default class FileUploaderErrorTitle {
    static [types.NOT_ALLOWED_FILE_SIZE] = 'Недопустимый размер файла';
    static [types.NOT_ALLOWED_FILE_TYPE] = 'Недопустимый тип файла';
    static [types.NOT_ALLOWED_FILE_COUNT] = 'Недопустимое количество файлов, разрешено';
}
